export default "__VITE_ASSET__4319f7be__"